import { render, staticRenderFns } from "./ProductManuals.vue?vue&type=template&id=12ecb70e"
import script from "./ProductManuals.vue?vue&type=script&lang=js"
export * from "./ProductManuals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12ecb70e')) {
      api.createRecord('12ecb70e', component.options)
    } else {
      api.reload('12ecb70e', component.options)
    }
    module.hot.accept("./ProductManuals.vue?vue&type=template&id=12ecb70e", function () {
      api.rerender('12ecb70e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApparatusDetails/ProductManuals.vue"
export default component.exports